import { createFileRoute } from '@tanstack/react-router';

import ProductRevisionPage from '@/components/products/specific/revisions/specific/Page';

export const Route = createFileRoute('/products/$id/revisions_/$revisionId')({
	component: ProductRevisionPage,
});
